// Copyright (c) 2015, NSQUARE Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

import FileUploader from "./file_uploader";

froggy.provide("froggy.ui");
froggy.ui.FileUploader = FileUploader;
